import React from 'react';
import CitationView from './CitationView';

export default (soid) => {
  return () => < CitationView serviceOfferingId={soid} />;
};
